// @flow
import Vue from 'vue'
import * as mutationTypes from './mutation-types'
import type { AuthenticationClientInterface } from '../../../services/authentication/authentication-client-interface'
import { LoginResult } from '../../../types/login-result'
import type { UserState } from './index'

export default {
  userLogin: async (
    { commit }: { commit: (string, ?Object) => void },
    payload: { username: string, password: string }
  ): Promise<void> => {
    const client: AuthenticationClientInterface = Vue.prototype.$container.authenticationClient
    const { username, password } = payload
    const result: LoginResult = await client.login(username, password)
    commit(mutationTypes.SET_TOKEN, result.token)
  },

  verifyPasswordResetToken: async (
    { commit }: { commit: (string, string) => void },
    payload: { resetToken: string }
  ): Promise<void> => {
    const client: AuthenticationClientInterface = Vue.prototype.$container.authenticationClient
    await client.verifyResetPasswordToken(payload.resetToken)
    commit(mutationTypes.SET_PASSWORD_RESET_TOKEN, payload.resetToken)
  },

  resetPassword: async (
    { state, commit }: { state: UserState, commit: (string) => void },
    payload: { password: string }
  ): Promise<void> => {
    const client: AuthenticationClientInterface = Vue.prototype.$container.authenticationClient
    await client.resetPassword(state.passwordResetToken, payload.password)
    commit(mutationTypes.DELETE_PASSWORD_RESET_TOKEN)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js